import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

interface ExchangeRate {
  base_currency: string;
  target_currency: string;
  rate: number;
  updated_at: string;
}

export function useExchangeRates() {
  const [rates, setRates] = useState<ExchangeRate[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRates = async () => {
      const { data, error } = await supabase
        .from('exchange_rates')
        .select('*')
        .order('base_currency');

      if (!error && data) {
        setRates(data);
      }
      setLoading(false);
    };

    fetchRates();
  }, []);

  const getRate = useCallback(
    (from: string, to: string): number | null => {
      if (from === to) return 1;
      const found = rates.find((r) => r.base_currency === from && r.target_currency === to);
      return found ? found.rate : null;
    },
    [rates]
  );

  const updatedAt = rates.length > 0 ? rates[0].updated_at : null;

  return { rates, loading, getRate, updatedAt };
}
